export function eventListener(targets, types, listeners, options) {
  const events = [];

  if (!Array.isArray(targets)) targets = [targets];
  if (!Array.isArray(types)) types = [types];
  if (!Array.isArray(listeners)) listeners = [listeners];

  initialize();

  function initialize() {
    const elements = targets.flatMap(target =>
      typeof target === 'string'
        ? [...document.querySelectorAll(target)]
        : [target]
    );

    if (elements.length === 0) return;

    elements.forEach(element => {
      types.forEach(type => {
        listeners.forEach(listener => {
          events.push(register(element, type, listener, options));
        });
      });
    });
  }

  function register(element, event, listener, options) {
    element.addEventListener(event, listener, options);

    return () => element.removeEventListener(event, listener, options);
  }

  function stop() {
    events.forEach(fn => fn());
    events.length = 0;
  }

  return stop;
}
